/**
 * Virtual parody companies (Sprint 3a) - fully fictional news actors.
 * Each company is tied to 1~2 affinity coins; company news templates
 * (coinNews.ts, companyId set) only fire for those coins.
 * All names are original inventions - no real-company references.
 */

export interface CompanyConfig {
  id: string;
  /** i18n key for display name */
  nameKey: string;
  /** coins this company's news can target */
  affinity: readonly string[];
  /** feed tag color (CSS hex) */
  color: string;
}

export const COMPANIES: CompanyConfig[] = [
  // EV maker - moves the blue-chip coin
  { id: 'voltmotors', nameKey: 'co_voltmotors', affinity: ['stonecoin'], color: '#00B4D8' },
  // Mega exchange - moves its flagship listings
  { id: 'moonbase', nameKey: 'co_moonbase', affinity: ['nebula', 'pumpking'], color: '#9B5DE5' },
  // Mining rig manufacturer
  { id: 'hashworks', nameKey: 'co_hashworks', affinity: ['stonecoin', 'nebula'], color: '#94A3B8' },
  // Entertainment agency - fuels the frog meme
  { id: 'moonlightent', nameKey: 'co_moonlightent', affinity: ['moonfrog'], color: '#F72585' },
  // Fried chicken franchise
  { id: 'goldenfry', nameKey: 'co_goldenfry', affinity: ['chickencoin'], color: '#F4A261' },
  // Aggressive investment fund
  { id: 'pumpcapital', nameKey: 'co_pumpcapital', affinity: ['pumpking', 'moonfrog'], color: '#FF5C8A' },
];

export function getCompany(companyId: string): CompanyConfig | undefined {
  return COMPANIES.find(c => c.id === companyId);
}
